// NGE-841: a stable per-browser device identifier for the activity-metrics
// multi-device union (D6) — lets the backend tell "same person, two tabs" apart
// from "two different devices". Persisted in localStorage; regenerated only if
// missing (never rotated on its own — rotating it would look like a new device
// to the interval-merge logic and fragment a user's session unnecessarily).

const DEVICE_ID_STORAGE_KEY = 'nexgen_device_id';

// Used when localStorage is unavailable; kept stable for the lifetime of the tab.
let fallbackDeviceId: string | null = null;

function generateDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for older browsers without crypto.randomUUID.
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) return existing;

    const created = generateDeviceId();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, created);
    return created;
  } catch {
    // localStorage unavailable (private browsing, disabled storage, etc.) —
    // fall back to a per-session id so callers always get a usable string.
    // Cached so it stays stable within the tab instead of a new id per call.
    if (!fallbackDeviceId) fallbackDeviceId = generateDeviceId();
    return fallbackDeviceId;
  }
}

export const DEVICE_KIND = 'web' as const;
